import { ComponentPropsWithoutRef } from 'react'
import clsx from 'clsx'

import styles from './SectionContainer.module.scss'

type SectionContainerProps = ComponentPropsWithoutRef<'div'> & {
  as?: 'div' | 'section'
}

export const SectionContainer = ({
  as: Component = 'div',
  className,
  ...props
}: SectionContainerProps) => (
  <Component className={clsx(styles.sectionContainer, className)} {...props} />
)
